import {mapActions} from 'pinia'
import { useSharedListStore } from "../../stores/sharedList"

export default {
  methods: {
    ...mapActions(useSharedListStore, ['getItems']),

    getSharedList(listName) {
      return this.getItems(listName);
    },

    importSharedLists(listNames) {
      listNames.forEach((listName) => {

        // If a list already has items, then skip import.
        if (this[listName] !== undefined) {
          if (Object.entries({...this[listName]}).length) return;
        }

        // Otherwise, import the shared list.
        this[listName] = this.getSharedList(listName);
      });
    }

  }
}
